import React, { useEffect } from 'react'
import './ECatalog.scss'

import Header from '../../../components/Turkey/Header/Header'
import UnderHeader from '../../../components/UnderHeader/UnderHeader'
import PageTitle from '../../../components/Turkey/PageTitle/PageTitle'
import Footer from '../../../components/Turkey/Footer/Footer'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import EcatalogContent from '../../../components/Turkey/EcatalogContect/EcatalogContent'

export default function ECatalog() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])
  
  return (
    <div>
      <Header page={'ecatalog'} />
      <UnderHeader className={'ecatalog'} />
      <PageTitle mainTitle={'E-KATALOG'} page={'E-KATALOG'} />
      <EcatalogContent />
      <LogoPartner />
      <Footer />
    </div>
  )
}
